<div class="container">
  <div class="title">
    <span class="app-title">Carol Bells</span>
    <span class="page-title">Login</span>
  </div>
  <form (submit)="login()">
  <mat-card class="login-container" appearance="outlined">
    <mat-form-field>
      <mat-label>Username</mat-label>
      <input type="text" name="username" matInput [(ngModel)]="username">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Password</mat-label>
      <input type="password" name="password" matInput [(ngModel)]="password">
    </mat-form-field>
    <button type="submit" mat-fab extended>Submit</button>
  </mat-card>
</form>
</div>
